@if (facade.selectedDrone(); as drone) {
  <aside class="drone-details" aria-label="Selected drone details">
    <div class="drone-details__header">
      <span class="drone-details__title">Drone</span>
      <button
        class="drone-details__close"
        type="button"
        aria-label="Close selected drone details"
        (click)="facade.clearSelectedDrone()"
      >
        &times;
      </button>
    </div>

    <dl class="drone-details__list">
      <div>
        <dt>Drone ID</dt>
        <dd>{{ drone.droneId }}</dd>
      </div>
      <div>
        <dt>Confidence</dt>
        <dd>{{ drone.confidence }}%</dd>
      </div>
      <div>
        <dt>Observers</dt>
        <dd>{{ drone.observerCount }}</dd>
      </div>
      <div>
        <dt>Last seen</dt>
        <dd>{{ drone.lastSeenAtUtc | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }} UTC</dd>
      </div>
      <div>
        <dt>Source observer IDs</dt>
        <dd>{{ facade.formatSourceIds(drone.sourceObserverIds) }}</dd>
      </div>
      <div>
        <dt>Source ray IDs</dt>
        <dd>{{ facade.formatSourceIds(drone.sourceRayIds) }}</dd>
      </div>
    </dl>
  </aside>
}
